// extracted by mini-css-extract-plugin
module.exports = {"NotesModule":"NotesModule_NotesModule__V2g86","Header":"NotesModule_Header__1w-OJ"};